import { DataGridColSettings } from '@/components/DataGrid/utils';

export const bookingHistoryDataGridCols: DataGridColSettings[] = [
  {
    field: 'bookingNumber',
    headerName: 'Booking Number',
    visible: true,
  },
  {
    field: 'agency',
    headerName: 'Agency Booked For',
    visible: true,
  },
  {
    field: 'bookingType',
    headerName: 'Booking Type',
    visible: true,
  },
  {
    field: 'bookingOfficer',
    headerName: 'Booking Officer',
    visible: true,
  },
  {
    field: 'initialBookingDate',
    headerName: 'Initial Booking Date',
    visible: true,
  },
  {
    field: 'lastIntakeDate',
    headerName: 'Last Intake Date',
    visible: true,
  },
  {
    field: 'caseNumber',
    headerName: 'Case Number',
    visible: true,
  },
  {
    field: 'bookingDisposition',
    headerName: 'Booking Disposition',
    visible: true,
  },
  {
    field: 'scheduledRelease',
    headerName: 'Scheduled Release',
    visible: true,
  },
  {
    field: 'actualRelease',
    headerName: 'Actual Release',
    visible: true,
  },
  {
    field: 'status',
    headerName: 'Status',
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 100,
    visible: true,
  },
];
